export default {
    login_verification_text: "Hola {user}, te enviamos un código de verificación a {email}. Ingresa el código para iniciar sesión",
    code_resent: "Código de verificación reenviado exitosamente",
}
